window.boa = window.boa || {};
var vimeoplrs = []; //array to dynamically add all vimeo players
var rtime;
var timeout = false;
var delta = 200;
var tiledelay;
var $heroVideo; //for caching
var $heroPlaying = true;

boa.init = function () {
    boa.cacheSelectors();
    boa.isMobile();
    boa.navigation();
    boa.blockLink();
    boa.matchHeight();
    boa.validation();
    boa.stickyHeader();
    boa.blocks();
    boa.scrollTo();
    boa.autoScroll();
    boa.sequence();
    boa.revealOnScroll();
    boa.modal();
    boa.tiles();
    boa.hero();
    boa.infopop();
    //boa.videoContainer();
    boa.vimeoVideos();
    //boa.responsiveVideos();
};

boa.infopop = function () {
    $('.infopop-open').on('click', function(e){
        e.preventDefault();
        $('.infopop').addClass('show');
    });

    $('.infopop-close').on('click', function(e){
        e.preventDefault();
        $('.infopop').removeClass('show');

        $.ajax({
            type: 'POST',
            url: '/functions/ajax.php',
            dataType: 'json',
            data: {
                m: 'infopop',
                l: $('html').attr('lang'),
                v: 1
            }
        });
    });

    $.ajax({
        type: 'POST',
        url: '/functions/ajax.php',
        dataType: 'json',
        data: {
            m: 'infopop_check',
            l: $('html').attr('lang'),
            v: 1
        },
        success: function (response) {
            if (response != true) {
                $('.infopop').addClass('show');
            }
        }
    });

};

boa.cacheSelectors = function () {
    boa.cache = {
        isMobile : false,
        header   : $('.page-header'),
        pagewrap : $('.page-wrap'),
    };
};

boa.isMobile = function () {
    var deviceAgent = navigator.userAgent.toLowerCase();
    boa.cache.isMobile = (deviceAgent.match(/(iphone|ipod|ipad)/) || deviceAgent.match(/(android)/) || deviceAgent.match(/(iemobile)/) || deviceAgent.match(/iphone/i) || deviceAgent.match(/ipad/i) || deviceAgent.match(/ipod/i) || deviceAgent.match(/blackberry/i) || deviceAgent.match(/bada/i)) || (/OS [1-4]_[0-9_]+ like Mac OS X/i.test(navigator.userAgent));
    if (boa.cache.isMobile) {
        $('html').addClass('mobile');
    } else {
        $('html').addClass('no-mobile');
    }
}

boa.navigation = function () {
    $('.main-nav .hamburger-menu').click(function (e) {
        e.preventDefault();
        $(this).next('.nav-wrap').slideToggle('fast');
        $(this).find('.bar').toggleClass("animate");
    });
};

boa.vimeoVideos = function(){

    //documentation: https://github.com/vimeo/player.js

    var vimeoVideos = $('.vimeo-player');
    if(vimeoVideos.length){
        var lastVidId;
        vimeoVideos.each(function(){
            var vurl = $(this).data("video");
            if(vurl != '')
            {
                var vurlexp = vurl.split('#start=');
                //console.log(vurlexp);
                var vid = vurlexp[0];
                var vstart = 0;
                if(vurlexp.length>1){
                    vstart = parseFloat(vurlexp[1]);
                }
                $(this).attr('data-start',vstart);
                $(this).addClass('firsttime');
                var options = {
                    id: vid,
                    autoplay: false,
                    autopause: true,
                    loop: true,
                    playsinline: false,
                    background: true,
                    title: false,
                    byline: false,
                    muted: true,
                }
                var vidId = $(this).attr('id');
                lastVidId = vidId;
                ////console.log(vidId);
                vimeoplrs[vidId] = new Vimeo.Player(vidId, options);
            }
        });
        //do responsive actions if last video is loaded
        vimeoplrs[lastVidId].on('loaded',boa.responsiveVideos);
    }
}

boa.responsiveVideos = function ()
{
    var selector = $(".iframe-container");
    setup_video_iframe(selector);
    //console.log('responsive videos');
    selector.each(function() {

        var vVideo		= $(this).find('iframe');
        var vContainer	= $(this)
        var vidId       = vContainer.attr('id');
        var player      = vimeoplrs[vidId];

        //video autoplays when background option is false (even if autoplay is set to false)
        if(player) {
            player.pause();
        }else{
            return false;
        }

        //show video (opacity is still 0)
        vVideo.show();

    //	var video = document.getElementById(vVideo.prop('id')); //document.getElementsByTagName('video')[0];
        if(vContainer.hasClass('vimeo-hero')) {
            vVideo.css('opacity',0).animate({opacity:1},500);
            setTimeout(function(){boa.playVimeo(vidId);},250);
        } else if(vContainer.hasClass('vimeo-hover')) {
            vContainer.closest('a').hover(
                function () {
                    boa.playVimeo(vidId);
                },
                function () {
                    player.pause();
                }
            );
        }
    });
};
boa.playVimeo = function(vid){
    var player = vimeoplrs[vid];
    var vContainer	= $('#'+vid);
    //if first time playing and start time is set
    if(vContainer.hasClass('firsttime')){
        vContainer.removeClass('firsttime');
        if(vContainer.data('start')){
            var vstart = vContainer.data('start');
            //console.log('set start time',vstart);
            player.setCurrentTime(vstart);
        }
    }
    pause_videos();
    player.play();
    //force focus to avoid disappearing text (forces redraw of browser dom)
    setTimeout(function(){vContainer.parent().parent().redraw();},250);
}
boa.blockLink = function () {
    $('.block-link').click(function(e) {
        e.preventDefault();
        var url = $(this).find('.target').attr('href');
        window.location = url;
    });
};

boa.matchHeight = function () {
    if ($('.mh').length) {
        $(".mh > *").matchHeight();
    }
    if ($('.mh-item').length) {
        $(".mh-item").matchHeight();
    }
};

boa.validation = function () {
    if ($('.validate').length) {
        if (!Modernizr.touch) {
            $('.validate').validationEngine();
        } else {
            $('.validate').validationEngine({scroll: false});
        }
    }
};

boa.stickyHeader = function () {
    if (!boa.cache.isMobile && $('.page-header').length) {
        var headroom = new Headroom(document.querySelector(".page-header"), {
         tolerance: 0,
         offset : 400
         });
         headroom.init();
    }
};

boa.scrollTo = function () {
	'use strict';

    $('a[href^="#"]:not(.fp-link)').click(function()
	{
		var elemnt = $($(this).attr("href"));
		var offset = elemnt.offset();

        $('html, body').animate({
            scrollTop: offset.top
        }, 'slow');
        return false;
    });
};

boa.autoScroll = function(){
    //https://stackoverflow.com/questions/25839487/auto-scroll-to-next-anchor-at-mouse-wheel?answertab=active#tab-top

    var delay = false;
    var a = $('.auto-scroll');
    if(a.length){
        $(document).on('mousewheel DOMMouseScroll', function(event) { //event.preventDefault();
            console.log('mouse');
            if(delay) return;

            delay = true;
            setTimeout(function(){delay = false},500);

            var doautoscroll = false;
            var autoscrollmargin = $(window).height()/2;
            var wd = event.originalEvent.wheelDelta || -event.originalEvent.detail;

            if(wd < 0) {    //naar beneden scrollen
                for(var i = 0 ; i < a.length ; i++) {
                    var t = a[i].getClientRects()[0].top;
                    var b = a[i].getClientRects()[0].bottom;
                    if(t >= 40) break;
                }

                if(t<=autoscrollmargin){
                    //console.log((b-t)/2,t,b,'auto scroll');
                    ////console.log('top ok');
                    doautoscroll = true;
                }
            }
            else {          //naar boven scrollen
                for(var i = a.length-1 ; i >= 0 ; i--) {
                    var t = a[i].getClientRects()[0].top;
                    var b = a[i].getClientRects()[0].bottom;
                    if(t < -20) break;
                }
                if(b>=autoscrollmargin){
                    //console.log((b-t)/2,t,b,'auto scroll');
                    ////console.log('bottom ok');
                    doautoscroll = true;
                }
            }

            if(i >= 0 && i < a.length && doautoscroll) {
                //console.log('block scroll wheel');
                event.preventDefault();
                $('html,body').animate({
                    scrollTop: a[i].offsetTop
                }, 'slow');
            }
        });
    }
}

boa.sequence = function () {
    if ($('.center-slider').length) {
        $('.center-slider').slick({
            //dots: true,
            infinite: true,
            centerMode: true,
            slidesToShow: 3,
            speed: 500,
            centerPadding: '0px',
        });
    };

    /*if ($('.sequence-slider').length) {
        var $slider = $('.sequence-slider').slick({
            dots: false,
            arrows: false,
            infinite: false,
            speed: 100,
            fade: false,
            cssEase: 'linear',
            autoplay: true,
            autoplaySpeed: 1,
        });
    };*/

        /* $(".slick-center").addClass(
         "switch");
         $(".slick-current").prev().addClass(
         "switch");
         $('.slider').on('init', function(currentSlide) {
         //console.log(currentSlide);
         $(".slick-center").prev().toggleClass("switch");
         }); */

        /*$('.card-slider').on('afterChange', function(){
            boa.matchHeight();
        });

        $('.c-slick-prev').click(function () {
            $('.card-slider').slick('slickPrev');
        })
        $('.c-slick-next').click(function () {
            $('.card-slider').slick('slickNext');
        })*/
};

boa.hero = function () {
	'use strict';

	$heroVideo =  $("#hero__video"); //caching

    if($heroVideo.length)
    {
		/*if($heroVideo.data("video") != '')
		{
            var options = {
                id: $heroVideo.data('video'),
                autoplay: false,
                loop: true,
                playsinline: false,
                background: true,
                title: false,
                byline: false,
                muted: true,
            }
            var vidId = $heroVideo.attr('id');
            vimeoplrs[vidId] = new Vimeo.Player($heroVideo.attr('id'), options);
            vimeoplrs[vidId].on('loaded',boa.responsiveVideos);
		}*/

		setTimeout(function()
		{
			$('h1.animated').addClass('fadeOut');
		}, 7000);
    }

    if($(".hero__scroll").length) {
        $('.hero__scroll').click(function () {
            var $element = $(".hero").next();
            ////console.log($element);
            $('html, body').animate({
                scrollTop: $element.offset().top
            }, 'slow');
        })
    }
};

boa.revealOnScroll = function () {
    window.sr = ScrollReveal();
    sr.reveal('.sr-fade', {
        scale: 1,
        distance: '0',
        duration: 2000,
        viewFactor: 0,
        opacity: 0
    });
    /* Vertical fade */
    sr.reveal('.sr-top', {
        origin: 'top',
        scale: 1,
        distance: '40px',
        duration: 1000,
        viewFactor: 0,
    });
    sr.reveal('.sr-bottom', {
        scale: 1,
        distance: '40px',
        duration: 1000,
        viewFactor: 0,
    });
    /* Horizontal fade */
    sr.reveal('.sr-right', {
        origin: 'right',
        scale: 1,
        distance: '100px',
        duration: 1500,
        viewFactor: 0,
    });
    sr.reveal('.sr-left', {
        origin: 'left',
        scale: 1,
        distance: '1000px',
        duration: 1500,
        viewFactor: 0,
    });
};

boa.modal = function () {
    var elements = $('.modal-overlay, .modal');
    $('.modal-trigger').click(function(){
        elements.addClass('modal--active');
    });
    $('.modal__close, .modal-extra').click(function(){
        elements.removeClass('modal--active');
    });
};

boa.tiles = function () {
    if ($('.tiles').length) {

        /*if ( $("#video-1").length ) {
            video1 = videojs('video-1');
        }
        if ( $("#video-2").length ) {
            video2 = videojs('video-2');
        }
        if ( $("#video-3").length ) {
            video3 = videojs('video-3');
        }
        if ( $("#video-4").length ) {
            video4 = videojs('video-4');
        }
        if ( $("#video-5").length ) {
            video5 = videojs('video-5');
        }
        if ( $("#video-6").length ) {
            video6 = videojs('video-6');
        }*/

        $('.tiles__front .tile').mouseenter(function () {
            $this = $(this);
            $this.addClass("tile__active");
            $this.siblings(".tile").removeClass("tile__active").addClass("tile__fade");

            $tile = $('.tiles__back .tile').eq($this.index());
            $tile.siblings(".tile").hide();
            $tile.show();
            /*$tile.addClass("tile__active");
            $tile.siblings(".tile").removeClass("tile__active").addClass("tile__hidden");*/

            pause_videos();
            var vid = $tile.find('.vimeo-player:first').attr('id');
            setup_video_iframe($('#'+vid));
            tiledelay = setTimeout(function(){boa.playVimeo(vid);},500);

        });
        $('.tiles__front .tile').mouseleave(function () {
            $this = $(this);
            $this.removeClass("tile__active");
            $this.siblings(".tile").removeClass("tile__fade");
            clearTimeout(tiledelay);
            /*$tile = $('.tiles__back .tile').eq($this.index());
            $tile.siblings(".tile").hide();
            $tile.hide();*/
            /*$tile.removeClass("tile__active");
            $tile.siblings(".tile").removeClass("tile__hidden");*/

            //window['video' + ($this.index() + 1)].pause();
            pause_videos();
        });
    }
}

boa.blocks = function () {
	'use strict';

	if ($('.blocks').length) {
        $('.block').click(function (e) {
            $(this).addClass("block--active");
        });
    }

    var $fullpage = $('#full-page');

    if($fullpage.length)
    {
		var aPages = new Array();

		$fullpage.find('div.section').each(function () {
			aPages.push($(this).data('anchor'));
		});
        $('#full-page').fullpage({
            scrollingSpeed: 1000,
            menu: '#fp-menu',
            anchors: fpAnchors,
            responsiveWidth: 9000,
			scrollBar: false,
			autoScrolling: true,
        });
    }
}

boa.afterresize = function(){
    if($('#hero').length){
        setup_video_iframe($(".iframe-container"));
    }
}

boa.vimeoInViewport = function(){
    //video height is not taken into account, we consider the video to be window height or less
    var viv = $('.vimeo-inviewport');
    if(viv.length){
        var wh = $(window).height();
        var ws = $(window).scrollTop();
        viv.each(function(){
            var vivtop = $(this).offset().top;
            //console.log(ws,vivtop,wh);
            if((ws<vivtop+wh && ws>=vivtop-wh) && !$(this).hasClass('vivplaying')){
                //play movie
                pause_videos();
                var vid = viv.attr('id');
                boa.playVimeo(vid);
                $(this).addClass('vivplaying');
                //console.log(vid,'play');
            }else if((ws>=vivtop+wh || ws<vivtop-wh) && $(this).hasClass('vivplaying')){
                //pause movie
                var vid = viv.attr('id');
                vimeoplrs[vid].pause();
                $(this).removeClass('vivplaying');
                //console.log(vid,'pause');
            }
        })
    }
}

boa.onScroll = function(){
    boa.vimeoInViewport();

    var scroll = $(window).scrollTop();
    if( scroll >= $(window).height()){
        $('.infopop-close').click();
    }
};

// initialize on docready
$(boa.init);

// buggyfill for vh on iOS
window.viewportUnitsBuggyfill.init({
    refreshDebounceWait: 50,
    hacks: window.viewportUnitsBuggyfillHacks
});

// matchHeight
$(window).on('load', function(){
    boa.matchHeight();
    setTimeout(function(){ boa.matchHeight(); }, 2000);
	setTimeout(function(){ $('.page-cta,.promo-cta').addClass('show'); }, 5000);
    $('.promo-cta .promo-cta-close').on('click',function(){
        console.log('click');
        $(this).parent().remove();
        $.ajax({
            url: '/functions/ajax.php',
            type: 'POST',
            dataType: 'json',
            data: {
                m       :   'nopromo'
            },
            success: function(response){
                console.log('nopromo');
            }
        });

    })
});

$(window).on('resize', function(){
    rtime = new Date();
    if (timeout === false) {
        timeout = true;
        setTimeout(resizeend, delta);
    }
});
$(window).on('scroll',function(){
    clearTimeout($.data(this, 'scrollTimer'));
    $.data(this, 'scrollTimer', setTimeout(function() {
        boa.onScroll();
    }, 500));
});

function resizeend() {
    if (new Date() - rtime < delta) {
        setTimeout(resizeend, delta);
    } else {
        timeout = false;
        boa.afterresize();
    }
}

function setup_video(selector)
{
	selector.each(function()
	{
		var vVideo		= $(this);
		var vContainer	= vVideo.closest('.block__video');
	//	var vElement	= vVideo.get(0);

		var videoDimensions = {
			'x': 1920,	//vContainer.hasData('width')  && vContainer.data('width')  > 0 ? vContainer.data('width')  :
			'y': 1080	//vContainer.hasData('height') && vContainer.data('height') > 0 ? vContainer.data('height') :
		};
		var containerDimensions = {
			x: vContainer.width(),
			y: vContainer.height()
		};

		var newWidth, newHeight;

		var maxRatio = Math.min(videoDimensions.x / containerDimensions.x, videoDimensions.y / containerDimensions.y);

		newWidth  = videoDimensions.x / maxRatio;
		newHeight = videoDimensions.y / maxRatio;

		vVideo.css({
			width		: newWidth,
			height		: newHeight,
			marginTop	: (-newHeight/2),
			marginLeft	: (-newWidth/2)
		}).show(); //eerst positie en afm goed zetten, dan tonen

		var video = document.getElementById(vVideo.prop('id')); //document.getElementsByTagName('video')[0];

	});
}

function setup_video_iframe(selector){
    selector.each(function(){
        var vVideo		= $(this).find('iframe');
        var vContainer	= $(this);

        //console.log('setup video iframe',$(this).attr('id'));

        vVideo.attr('allowtransparency',true);

        var videoDimensions = {
            'x': 1920, 'y': 1080
        };
        var containerDimensions = {
            x: vContainer.width(), y: vContainer.height()
        };

        var newWidth, newHeight;

        var maxRatio = Math.min(videoDimensions.x / containerDimensions.x, videoDimensions.y / containerDimensions.y);

        newWidth  = videoDimensions.x / maxRatio;
        newHeight = videoDimensions.y / maxRatio;

        vVideo.css({
            width		: newWidth,
            height		: newHeight,
            marginTop	: (-newHeight/2),
            marginLeft	: (-newWidth/2)
        });
    });
}

function pause_videos(){
    $('video').each(function(){
        //console.log($(this).attr('src'),'pause');
        $(this).get(0).pause();
    });
    $('.vimeo-player').each(function(){
        var vid = $(this).attr('id');
        //console.log(vid,'pause');
        vimeoplrs[vid].pause();
    });
}
jQuery.fn.redraw = function() {
    //fixate height of container to avoid scroll jump bug
    var parent = this.parent();
    parent.css('height',parent.height());
    console.log('height',parent.height());
    //redraw
    this.css('display', 'none');
    var temp = this[0].offsetHeight;    //this call forces redraw
    this.css('display', '');
    temp = this[0].offsetHeight;   //this call forces redraw
    //release height
    parent.css('height','');
};